import React from 'react';
import * as PropTypes from 'prop-types';
import cx from 'classnames';
import './style.scss';

const Close = ({ className, ...rest }) => {
  return (
    <div className={cx('ap-close-button', className)} {...rest} />
  );
};

Close.propTypes = {
  className: PropTypes.string
};

export default Close;
